import type { ReactNode } from 'react';

export function Card({
  title,
  description,
  action,
  children,
}: {
  title?: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}): JSX.Element {
  return (
    <section
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      {(title || description || action) && (
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            padding: '16px 20px 12px',
            gap: 16,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 }}>
            {title && (
              <h2
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'var(--text)',
                  margin: 0,
                  letterSpacing: '-0.005em',
                }}
              >
                {title}
              </h2>
            )}
            {description && (
              <p
                style={{
                  fontSize: 11,
                  color: 'var(--text-dim)',
                  margin: 0,
                  lineHeight: 1.5,
                  fontWeight: 400,
                }}
              >
                {description}
              </p>
            )}
          </div>
          {action && <div>{action}</div>}
        </header>
      )}
      <div style={{ padding: '8px 20px 20px' }}>{children}</div>
    </section>
  );
}
